/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";

const TableFooter = ({ range, setPage, page, slice,total }) => {
  React.useMemo(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
  }, [slice, page, setPage]);

  return (
    <div className="table-class">
      <button className={range.length <= 1 || page === 1 ? "btn-disabled" : "btn-primary"}
              onClick={() =>  {return page === 1 ? '' : setPage(page-1)}}>Prev</button>
      <button className="btn-primary" >{page}</button>
      <button className={range <= 1 || range.length === page ? "btn-disabled" : "btn-primary"}
              onClick={() => setPage(page+1)}>Next</button>
      <div>Total {total}</div>        
    </div>
  );
};

export default TableFooter;
